import {
  faBullhorn,
  faRocket,
  faUsers,
} from '@fortawesome/pro-regular-svg-icons';
import { Status } from '@constants/status';

export const nodeStatus = {
  add: 'add',
  pending: 'pending',
  complete: 'complete',
  active: 'active',
} as const;

export const subwaySortField = {
  created: 'created_at',
  name: 'name',
  status: 'status',
  id: 'id',
} as const;

export const subwaySortDirection = {
  asc: 'asc',
  desc: 'desc',
} as const;

export const subwaySortOptions = [
  {
    label: 'Date Created - oldest first',
    value: subwaySortField.created,
    order: subwaySortDirection.asc,
  },
  {
    label: 'Date Created - newest first',
    value: subwaySortField.created,
    order: subwaySortDirection.desc,
  },
  {
    label: 'Name - A to Z',
    value: subwaySortField.name,
    order: subwaySortDirection.asc,
  },
  {
    label: 'Name - Z to A',
    value: subwaySortField.name,
    order: subwaySortDirection.desc,
  },
  {
    label: 'ID - A to Z',
    value: subwaySortField.id,
    order: subwaySortDirection.asc,
  },
  {
    label: 'ID - Z to A',
    value: subwaySortField.id,
    order: subwaySortDirection.desc,
  },
  {
    label: 'Status - A to Z',
    value: subwaySortField.status,
    order: subwaySortDirection.asc,
  },
  {
    label: 'Status - Z to A',
    value: subwaySortField.status,
    order: subwaySortDirection.desc,
  },
];
export const entityVariant = {
  campaign: 'campaign',
  group: 'group',
  launch: 'launch',
} as const;

export const iconList = {
  [entityVariant.campaign]: faBullhorn,
  [entityVariant.group]: faUsers,
  [entityVariant.launch]: faRocket,
} as const;

export const chipStatus = {
  [Status.DRAFT]: 'Draft',
  [Status.ACTIVE]: 'Active',
  [Status.INACTIVE]: 'Paused',
  [Status.PENDING]: 'Pending',
  [Status.ARCHIVED]: 'Archived',
  UNSAVED: 'Unsaved',
} as const;

export const entityIdPrefix = {
  [entityVariant.campaign]: 'CMP-',
  [entityVariant.group]: 'ADG-',
  [entityVariant.launch]: '',
} as const;
